
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/title/[id]",
      function () {
        return require("private-next-pages/title/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/title/[id]"])
      });
    }
  